import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PortfolioEvidenceType } from '@core/enums/portfolio';
import { IStudentEvidence } from '@core/interfaces/iclass-portfolio';
import { setIconDisplayObject } from '@core/services/helper.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-student-evidence',
    templateUrl: './student-evidence.component.html',
    styleUrls: ['./student-evidence.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StudentEvidenceComponent implements OnInit {
  @Input() students: IStudentEvidence[] = [];
  @Output() student = new EventEmitter();

  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  infoIconColumnConfig = {
    type: 'infoIcon',
    colorClass: 'text-drdpblue-300',
    cursorClass: 'cursor-pointer'
  };

  tableColumns = [
    { columnDef: 'firstName', header: this.translocoService.translate('user.dashboard.portfolio.table.firstName'), type: 'text' },
    { columnDef: 'lastName', header: this.translocoService.translate('user.dashboard.portfolio.table.lastName'), type: 'text' },
    { columnDef: 'total', header: this.translocoService.translate('user.dashboard.portfolio.table.totalItems'), type: 'text' },
    { columnDef: 'review', header: this.translocoService.translate('user.dashboard.portfolio.table.reviewEvidencePage'), type: 'icon', icon: 'notes', colorClass: 'text-drdpblue-300', cursorClass: 'cursor-pointer' },
    { columnDef: 'photo', header: this.translocoService.translate('user.dashboard.portfolio.table.photoEvidence'), icon: 'images', ...this.infoIconColumnConfig },
    { columnDef: 'video', header: this.translocoService.translate('user.dashboard.portfolio.table.videoEvidence'), icon: 'video', ...this.infoIconColumnConfig },
    { columnDef: 'audio', header: this.translocoService.translate('user.dashboard.portfolio.table.audioEvidence'), icon: 'volume', ...this.infoIconColumnConfig },
    { columnDef: 'note', header: this.translocoService.translate('user.dashboard.portfolio.table.noteEvidence'), icon: 'notes', ...this.infoIconColumnConfig },
  ];

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.initializeTableData();
  }

  initializeTableData(): void {
    if(this.students && this.students.length) {
      this.students = this.students.map(student => ({
        ...student,
        total: student.evidences?.length || 0,
        photo: student.evidences?.filter(e => e.evidenceTypeId === PortfolioEvidenceType.Photo).length || 0,
        audio: student.evidences?.filter(e => e.evidenceTypeId === PortfolioEvidenceType.Audio).length || 0,
        video: student.evidences?.filter(e => e.evidenceTypeId === PortfolioEvidenceType.Video).length || 0,
        note: student.evidences?.filter(e => e.evidenceTypeId === PortfolioEvidenceType.Note).length || 0,
        displayIcons: setIconDisplayObject(this.tableColumns, student)
      }));
      this.dataSource = new MatTableDataSource(this.students);
    }
  }

  onReviewEvidence(event: any): void {
    this.student.emit(event);
  }
}
